
import Vue, { PropType } from 'vue'

// import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
import JImageGallery from '@/ui/controls/JImageGallery.vue'
// import JImageCard from '@/ui/controls/JImageCard.vue'

import LogTimelineByDateDayItem from '@/ui/components/timeline/LogTimelineByDateDayItem.vue'

import LogItem from '@/models/LogItem'
import { id, dateOnly } from '@/types/models'
import Image from '@/models/Image'
import { formatDate } from '@/helpers/formatters'

export default Vue.extend({
  components: {
    // PlantAvatar,
    JImageGallery,
    // JImageCard,

    LogTimelineByDateDayItem,
  },
  props: {
    value: String as PropType<dateOnly>,
    logItems: Array as PropType<Array<LogItem>>,
    hideIcon: Boolean,

    dense: Boolean,
    // hidePlants: Boolean,
    // dense: Boolean,

    imageId: String,
  },
  data: () => ({
    // imageDialog: false,
  }),
  computed: {
    date(): dateOnly {
      return this.value
    },
    today(): dateOnly {
      return new Date().toISOString().split('T')[0]
    },
    categories(): string[] {
      return [...new Set(this.logItems.map((li) => li.category))]
    },

    // item(): LogItem {
    //   return this.value
    // },

    // cardTitle(): string | undefined {
    //   switch (this.item.category) {
    //     case 'action':
    //     case 'milestone':
    //       return this.item.type
    //     case 'image':
    //       return this.item.category // undefined
    //     case 'water':
    //       return this.item.category + (this.item.type === 'normal' ? '' : ' (' + this.item.type + ')')
    //     case 'comment':
    //       return this.item.category + (this.item.type === 'n/a' ? '' : '(' + this.item.type + ')')
    //     default:
    //       return this.item.category + ': ' + this.item.type
    //   }
    // },
  },
  methods: {
    formatDate: formatDate,
    getImage(imageId: id): Image {
      return this.$store.getters['gardens/images/find'](imageId)
    },
  },
})
